import { useEffect } from "react";
import i18next from "src/i18n/config";

import { showErrorToast } from "./Toasts";

type QueryResultLike = {
    isError: boolean;
    error?: unknown;
    requestId?: string;
};

export function getErrorMessage(error: unknown, fallbackMessage = i18next.t("common:toast.generalError")): string {
    const message = (error as { message?: unknown } | null | undefined)?.message;
    return typeof message === "string" && message ? message : fallbackMessage;
}

// Several components often subscribe to the same cache entry, so a failed request is remembered by its id to toast it
// only once, however many of them call this hook.
const toastedRequestIds = new Set<string>();

// For components that have no error state of their own. Components that render one must not call this, or the user
// sees the failure twice.
export function useQueryErrorToast({ isError, error, requestId }: QueryResultLike): void {
    useEffect(() => {
        if (!isError || !requestId || toastedRequestIds.has(requestId)) {
            return;
        }
        toastedRequestIds.add(requestId);
        showErrorToast(getErrorMessage(error));
    }, [isError, error, requestId]);
}
